import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { api } from '../api';

function GoogleCallbackPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const handleCallback = async () => {
      // Check if this is a popup based on URL parameter and window size
      const isPopupFromUrl = searchParams.get('popup') === 'true';
      const isSmallWindow = window.innerWidth <= 600 && window.innerHeight <= 700;
      const isReallyPopup = isPopupFromUrl || isSmallWindow;
      
      if (isReallyPopup) {
        // SECURITY FIX: Replace innerHTML with safe DOM manipulation
        // Clear the body and create elements safely
        document.body.innerHTML = '';
        
        // Create the main container
        const container = document.createElement('div');
        container.style.cssText = `
          min-height: 100vh;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
          margin: 0;
          padding: 20px;
        `;
        
        // Create the card
        const card = document.createElement('div');
        card.style.cssText = `
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(10px);
          border-radius: 20px;
          padding: 40px;
          text-align: center;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
          max-width: 400px;
          width: 100%;
          animation: slideUp 0.5s ease-out;
        `;
        
        // Create the icon container
        const iconContainer = document.createElement('div');
        iconContainer.style.cssText = `
          width: 60px;
          height: 60px;
          background: #4285f4;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 20px;
          animation: checkmark 0.6s ease-in-out 0.3s both;
        `;
        
        // Create the SVG checkmark
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('width', '30');
        svg.setAttribute('height', '30');
        svg.setAttribute('viewBox', '0 0 24 24');
        svg.setAttribute('fill', 'none');
        svg.setAttribute('stroke', 'white');
        svg.setAttribute('stroke-width', '3');
        svg.setAttribute('stroke-linecap', 'round');
        svg.setAttribute('stroke-linejoin', 'round');
        
        const polyline = document.createElementNS('http://www.w3.org/2000/svg', 'polyline');
        polyline.setAttribute('points', '20,6 9,17 4,12');
        svg.appendChild(polyline);
        iconContainer.appendChild(svg);
        
        // Create the title
        const title = document.createElement('h2');
        title.style.cssText = `
          margin: 0 0 10px 0;
          color: #2d3748;
          font-size: 24px;
          font-weight: 600;
        `;
        title.textContent = 'Authentication Complete!';
        
        // Create the description
        const description = document.createElement('p');
        description.style.cssText = `
          margin: 0 0 20px 0;
          color: #718096;
          font-size: 16px;
          line-height: 1.5;
        `;
        description.textContent = 'Successfully signed in with Google. This window will close automatically.';
        
        // Create the progress bar
        const progressBar = document.createElement('div');
        progressBar.style.cssText = `
          width: 40px;
          height: 4px;
          background: linear-gradient(90deg, #4285f4, #34a853);
          border-radius: 2px;
          margin: 0 auto;
          animation: progress 1s ease-in-out;
        `;
        
        // Create the styles
        const style = document.createElement('style');
        style.textContent = `
          @keyframes slideUp {
            from { transform: translateY(30px); opacity: 0; }
            to { transform: translateY(0); opacity: 1; }
          }
          @keyframes checkmark {
            from { transform: scale(0); opacity: 0; }
            to { transform: scale(1); opacity: 1; }
          }
          @keyframes progress {
            from { width: 0; }
            to { width: 100%; }
          }
        `;
        
        // Assemble the DOM structure
        card.appendChild(iconContainer);
        card.appendChild(title);
        card.appendChild(description);
        card.appendChild(progressBar);
        container.appendChild(card);
        document.head.appendChild(style);
        document.body.appendChild(container);
        
        // Send postMessage to parent window
        try {
          const sessionId = searchParams.get('session_id');
          const message = {
            type: 'oauth-success',
            provider: 'google',
            sessionId,
            timestamp: Date.now()
          };
          
          if (window.opener && !window.opener.closed) {
            window.opener.postMessage(message, window.location.origin);
          }
        } catch (error) {
          console.error('PostMessage failed:', error);
        }
        
        // Close popup after animation
        setTimeout(() => {
          window.close();
        }, 1000);
        
        // Fallback close attempts
        setTimeout(() => {
          if (!window.closed) {
            window.close();
          }
        }, 1500);
        
        setTimeout(() => {
          if (!window.closed) {
            window.location.href = 'about:blank';
            setTimeout(() => window.close(), 100);
          }
        }, 2000);
        
      } else {
        // Not a popup - regular navigation to dashboard
        // Wait a bit for cookies to be properly set
        setTimeout(() => {
          window.location.href = '/dashboard';
        }, 500);
      }
    };

    handleCallback();
  }, [searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-black">
      <div className="text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-white">Processing login...</p>
      </div>
    </div>
  );
}

export default GoogleCallbackPage;